export default {"src":"/_next/static/image/public/images/ic_tag.66c2f2a865807fb3602d7b87357bc6f7.svg","height":25,"width":25};